import Api from '../../Base'

class PostShelfProductsWithPOS extends Api {
  requestUrl = `/api/shelf/${this.getParams().shelfId}/pos`

  method = 'POST'
}

export default PostShelfProductsWithPOS
